import React, { FC, ReactElement } from 'react'
import Loader from '../../../../React/Common/Components/Loader'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { DataListItem } from './DataListTypes'

export type { DataListItem } from './DataListTypes'

type Props = {
    items: readonly DataListItem[]
    isLoading?: boolean
    emptyMessage?: string
}

/**
 * Routed key/value list for detail pages such as application status.
 *
 * @param props Component props.
 * @returns Data list content.
 */
export const DataList: FC<Props> = ({ items, isLoading = false, emptyMessage = EMPTY_STRING }: Props): ReactElement => {
    if (isLoading) {
        return (
            <div className='router-datalist router-datalist--loading'>
                <Loader />
            </div>
        )
    }

    if (items.length === 0) return <div className='router-datalist router-datalist--empty'>{emptyMessage}</div>

    return (
        <div className='router-datalist'>
            <dl className='router-datalist-list'>
                {items.map(
                    ({ key, label, value, isSection, emphasiseError }: DataListItem): ReactElement =>
                        isSection ? (
                            <div key={key} className='router-datalist-section'>
                                <dt>{label}</dt>
                            </div>
                        ) : (
                            <div key={key} className='router-datalist-row'>
                                <dt>{label}</dt>
                                <dd
                                    className={
                                        emphasiseError === true ? 'router-datalist-value--emphasised-error' : undefined
                                    }
                                >
                                    {value ?? EMPTY_STRING}
                                </dd>
                            </div>
                        )
                )}
            </dl>
        </div>
    )
}
